export const getIndexYearAvailableFrom = (indexId, defaultYear) => {
  try {
    const indices = JSON.parse(localStorage.getItem("categories")) || [];
    if (!indices) return defaultYear;
    const selectedIndex = indices.find(category => category.id === indexId);

    if (selectedIndex && selectedIndex.available_from) {
      const fromDate = new Date(selectedIndex.available_from);
      return fromDate.getFullYear();
    }
    return defaultYear;
  } catch (error) {
    console.error('Error getting available_from:', error);
    return defaultYear;
  }
};

export const getIndexYearAvailableTo = (indexId, defaultYear) => {
  try {
    const indices = JSON.parse(localStorage.getItem("categories")) || [];
    const selectedIndex = indices.find(category => category.id === indexId);

    if (selectedIndex && selectedIndex.available_to) {
      const toDate = new Date(selectedIndex.available_to);
      return toDate.getFullYear();
    }
    return defaultYear;
  } catch (error) {
    console.error('Error getting available_to:', error);
    return defaultYear;
  }
};

